import { Component } from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormArray } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BackButtonComponent } from 'src/app/components/back-button/back-button.component';
import { ToastModule } from 'primeng/toast';
import { LambdaService } from 'src/app/services/lambda.service';
import { MessageService } from 'primeng/api';
import { MessageModule } from 'primeng/message';
import { Toast } from 'primeng/toast';
import { Ripple } from 'primeng/ripple';

@Component({
  selector: 'app-create-subscription',
  imports: [BackButtonComponent, CommonModule, InputTextModule, ToggleSwitchModule, CheckboxModule, ButtonModule, ToastModule, ReactiveFormsModule, MessageModule],
  templateUrl: './create-subscription.component.html',
  styleUrl: './create-subscription.component.scss',
  providers: [MessageService]
})
export class CreateSubscriptionComponent {

  form!: FormGroup;

  loading = false;

  productTypeOptions = [
    { label: 'Convencional', value: '1' },
    { label: 'Sesion', value: '2' },
    { label: 'Seguro', value: '3' },
    { label: 'Paquete', value: '4' }
  ];

  logOptions = [
    { label: 'Ordenes', name: 'sales', value: 0},
    { label: 'Beneficiarios', name: 'beneficiaries', value: 0},
    { label: 'Clientes', name: 'clients', value: 0}
  ];

  importExportOptions = [
    { label: 'Importar Clientes', name: 'importClients', value: 0},
    { label: 'Importar Productos', name: 'importProducts', value: 0},
    { label: 'Exportar Clientes', name: 'exportClients', value: 0},
    { label: 'Exportar Proveedores', name: 'exportProviders', value: 0}
  ];

  planOptions = [
    { label: 'Beneficiarios BO', name: 'beneficiariesBO', value: 0},
    { label: 'Planes por cliente BO', name: 'plansByClientBO', value: 0},
    { label: 'Beneficiarios CC', name: 'beneficiariesCC', value: 0},
    { label: 'Grafico Planes', name: 'plansChart', value: 0}
  ];

  constructor(
    private fb: FormBuilder,
    private lambdaService: LambdaService,
    private messageService: MessageService
  ) {
  }

  get shopProductTypesAllow(): FormArray {
    return this.form.get('shopProductTypesAllow') as FormArray;
  }

  get shopProductTypesAllowString(): string {
    console.log("valores ptyp",this.shopProductTypesAllow.value)
    return this.shopProductTypesAllow.value.join(',');
  }

  get shopImportExportAllowJson(): string {
    const importExportJson: { [key: string]: number } = {};
    for (const opt of this.importExportOptions) {
      importExportJson[opt.name] = opt.value;
    }
    return JSON.stringify(importExportJson);
  }

  get shopLogsAllowJson(): string {
    const logJson: { [key: string]: number } = {};
    for (const opt of this.logOptions) {
      logJson[opt.name] = opt.value;
    }
    return JSON.stringify(logJson);
  }

  get shopPlanAllowJson(): string {
    const planJson: { [key: string]: number } = {};
    for (const opt of this.planOptions) {
      planJson[opt.name] = opt.value;
    }
    return JSON.stringify(planJson);
  }

  ngOnInit(){
    this.form = this.fb.group({
      shopSubscriptionName: ['', [Validators.required, Validators.maxLength(100)]],
      shopPosAccess: [false],
      shopAnaliticsAccess: [false],
      shopMaxUsers: [null, [Validators.required, Validators.min(0), Validators.pattern(/^\d+$/)]],
      shopMaxProducts: [null, [Validators.required, Validators.min(0), Validators.pattern(/^\d+$/)]],
      shopProductTypesAllow: this.fb.array([], Validators.required),
      shopInfobipIntegrationAllow: [false],
      shopValidateClientAccess: [false],
      shopCalendarAccess: [false],
      shopCashRegisterAccess: [false],
      shopLogsAllow: this.fb.array([]),
      shopImportExportAllow: this.fb.array([]),
      shopPlanAllow: this.fb.array([])
    });
  }

  isSelected(value: string): boolean {
  return this.shopProductTypesAllow.value.includes(value);
  }

  onLogsCheckboxChange(event: any, option: any) {
    console.log("event", event);
    console.log("option", option);
    option.value = event.checked ? 1 : 0;
    console.log("logOptions", this.logOptions);
    console.log("logJson", this.shopLogsAllowJson);
  }

  onIECheckboxChange(event: any, option: any) {
    console.log("event", event);
    console.log("option", option);
    option.value = event.checked ? 1 : 0;
    console.log("importExportOptions", this.importExportOptions);
    console.log("importExportJson", this.shopImportExportAllowJson);
  }

  onPlanCheckboxChange(event: any, option: any) {
    console.log("event", event);
    console.log("option", option);
    option.value = event.checked ? 1 : 0;
    console.log("planOptions", this.planOptions);
    console.log("planJson", this.shopPlanAllowJson);
  }

  onPTCheckboxChange(event: any, value: string) {
    const productTypes: FormArray = this.shopProductTypesAllow;
    if (event.checked) {
      if (!productTypes.value.includes(value)) {
        productTypes.push(this.fb.control(value));
      }
    } else {
      const index = productTypes.controls.findIndex(x => x.value === value);
      if (index !== -1) {
        productTypes.removeAt(index);
      }
    }
    console.log("productTypes", productTypes);
    console.log("productTypes", this.shopProductTypesAllowString);
  }

  onSubmit() {
    this.loading = true;
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.createShopSubscription()

  }

  async createShopSubscription(){

    const formValue = this.form.value;

    await this.lambdaService.createShopSubscription(
      formValue.shopSubscriptionName,
      formValue.shopPosAccess ? 1 : 0,
      formValue.shopAnaliticsAccess ? 1 : 0,
      formValue.shopMaxUsers,
      formValue.shopMaxProducts,
      this.shopProductTypesAllowString,
      formValue.shopInfobipIntegrationAllow ? 1 : 0,
      formValue.shopValidateClientAccess ? 1 : 0,
      formValue.shopCalendarAccess ? 1 : 0,
      formValue.shopCashRegisterAccess ? 1 : 0,
      this.shopImportExportAllowJson,
      this.shopLogsAllowJson,
      this.shopPlanAllowJson
    ).then((data: any) => {
      if(data.status === 200){
        this.showSuccess();
        this.resetForm();
      }
      else{
        this.showError();
      }
      this.loading = false;
    }) .catch((error: any) => {
      console.error(error);
    })
  }

  resetForm() {
    // Vaciar FormArray
    while (this.shopProductTypesAllow.length !== 0) {
      this.shopProductTypesAllow.removeAt(0);
    }
    // Resetear formulario con valores iniciales
    this.form.reset({
      shopSubscriptionName: '',
      shopPosAccess: false,
      shopAnaliticsAccess: false,
      shopMaxUsers: null,
      shopMaxProducts: null,
      shopInfobipIntegrationAllow: false
    });
  }

  showSuccess() {
		this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Plan creado con éxito' });
	}

	showError() {
		this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al guardar' });
	}

}
